import service from '../utils/request';

// 获取推送消息列表
export const getPushMessages = (params) => {
  return service.post('/push/messages/query', params);
};

// 获取推送消息详情
export const getPushMessageDetail = (id) => {
  return service.get(`/push/messages/${id}`);
};

// 创建推送消息
export const createPushMessage = (data) => {
  return service.post('/push/messages', data);
};

// 更新推送消息
export const updatePushMessage = (id, data) => {
  return service.put(`/push/messages/${id}`, data);
};

// 删除推送消息
export const deletePushMessage = (id) => {
  return service.delete(`/push/messages/${id}`);
};

// 发送推送消息
export const sendPushMessage = (id) => {
  return service.post(`/push/messages/${id}/send`);
};

// 批量发送推送消息
export const batchSendPushMessages = (ids) => {
  return service.post('/push/messages/batch-send', { ids });
};

// 获取推送模板列表
export const getPushTemplates = (params) => {
  return service.post('/push/templates/query', params);
};

// 获取推送模板详情
export const getPushTemplateDetail = (id) => {
  return service.get(`/push/templates/${id}`);
};

// 创建推送模板
export const createPushTemplate = (data) => {
  return service.post('/push/templates', data);
};

// 更新推送模板
export const updatePushTemplate = (id, data) => {
  return service.put(`/push/templates/${id}`, data);
};

// 删除推送模板
export const deletePushTemplate = (id) => {
  return service.delete(`/push/templates/${id}`);
}; 